import React, { Fragment } from 'react';
import Slider from 'react-slick';

import Breadcrumbs from '../../../CommonComponents/Breadcrumbs/Breadcrumbs';

import { textSettings, navSettings, MAIN_TEXT_RUN, NOVELTY, LINEUP_NAV } from './constants';
import './HeaderSquidGame.scss';

export const HeaderSquidGame = ({ baseImgUrl }) => {
  const title = 'SQUID GAME × OWNDAYS';
  const breadcrumbs = [
    { path: '/sg/en', label: 'Homepage' },
    { path: '/sg/en/news', label: 'News' },
    { path: '#', label: title },
  ];

  const scrollToSection = id => {
    if (!id) return;

    const elementId = id.startsWith('#') ? id.substring(1) : id;
    const element = document.getElementById(elementId);

    window.location.hash = elementId;

    if (element) {
      const headerHeight = document.querySelector('header')?.offsetHeight || 0;
      let headerOffset = 0;

      if (window.innerWidth <= 767) {
        headerOffset = headerHeight - 140;
      } else {
        headerOffset = headerHeight - 80;
      }

      const elementTop = element.getBoundingClientRect().top + window.scrollY;

      window.scrollTo({
        top: elementTop - headerOffset,
        behavior: 'smooth',
      });
    }
  };

  const renderNavItem = () => {
    return LINEUP_NAV.map((name, i) => (
      <li
        key={`${name.toLowerCase().replace(' ', '-')}`}
        className="header-squid-game__lineup-nav__item"
        onClick={() => scrollToSection(`${name.toLowerCase().replace(' ', '-')}`)}
      >
        <span className="header-squid-game__lineup-nav__item-img">
          <img alt={name} src={`${baseImgUrl}/lineup/nav-${i + 1}.webp`} />
        </span>

        <span className="header-squid-game__lineup-nav__item-name">
          <strong
            style={{
              backgroundImage: `url("${baseImgUrl}/lineup/nav-text-${i + 1}.svg")`,
            }}
          >
            {name}
          </strong>
          <small>MODEL</small>
        </span>
      </li>
    ));
  };

  return (
    <Fragment>
      <Breadcrumbs crumbs={breadcrumbs} />

      <section className="header-squid-game__main">
        <div className="header-squid-game__main__wrapper">
          <h1 className="header-squid-game__main__logo">
            <span>{title}</span>
            <img alt={title} loading="lazy" src={`${baseImgUrl}/main/logo.webp`} />
          </h1>

          <div className="header-squid-game__main__schedule">
            <span className="header-squid-game__main__schedule-text">
              Official
              <br /> Release
            </span>
            <p className="header-squid-game__main__schedule-date">
              <small>Fri.</small>
              <span>27 June</span>
            </p>
            <span className="header-squid-game__main__schedule-year">2025</span>
            <span className="header-squid-game__main__schedule-time">at 10:00</span>
          </div>

          <div className="header-squid-game__main__content">
            <picture className="header-squid-game__main__young-hee">
              <source media="(min-width: 768px)" srcSet={`${baseImgUrl}/main/young-hee_pc.webp`} />
              <img
                alt="YOUNG-HEE"
                data-aos="fade-up"
                loading="lazy"
                src={`${baseImgUrl}/main/young-hee_sp.webp`}
              />
            </picture>

            <img
              alt="○△□"
              className="header-squid-game__main__symbolic"
              loading="lazy"
              src={`${baseImgUrl}/main/symbolic.webp`}
            />

            <div className="base-squid-game__text-run" data-section="main">
              <Slider {...textSettings} className="base-squid-game__text-run__list">
                {Array.from({ length: 10 })
                  .flatMap(() => MAIN_TEXT_RUN)
                  .map((text, index) => (
                    <div key={index}>
                      <li>{text}</li>
                    </div>
                  ))}
              </Slider>
            </div>
          </div>

          <div className="header-squid-game__main__desc">
            <div className="base-squid-game__container">
              <h2 className="header-squid-game__main__desc__title">
                <em>Netflix</em> worldwide hit drama series "SQUID GAME", collaborated with OWNDAYS!
              </h2>

              <p className="header-squid-game__main__desc__text">
                Dreaming of striking it rich, contestants risk everything in a high-stakes game in
                the gripping Netflix series SQUID GAME. We’ve captured its unique world through
                distinctive six frame design inspired by the show’s iconic imagery. The items are
                available to enhance your enjoyment of the latest season its coming. Wear the
                collaboration eyewear and join the “SQUID GAME”!
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="header-squid-game__novelty" id="novelty">
        <div className="base-squid-game__container">
          <h2 className="base-squid-game__title">
            <span>Exclusive to Pre-order</span>
            <strong>Novelty</strong>
            <img alt="Novelty" loading="lazy" src={`${baseImgUrl}/novelty/novelty.svg`} />
          </h2>

          <div className="header-squid-game__novelty__card">
            <div className="header-squid-game__novelty__card-bg"></div>

            <img
              alt="pink guard"
              className="header-squid-game__novelty__card-pg"
              data-aos="fade-up"
              loading="lazy"
              src={`${baseImgUrl}/novelty/pink-guard.webp`}
            />

            <p className="header-squid-game__novelty__card-subtitle">
              Applicable to customers who <br />
              purchase SQUID GAMES frames
            </p>

            <h3 className="header-squid-game__novelty__card-title">
              Exclusive collaboration <br />
              metal charm
            </h3>

            <div className="header-squid-game__novelty__card-products">
              <img
                alt="Metal charm (Yonghee ver.)"
                loading="lazy"
                src={`${baseImgUrl}/novelty/SG-CASE-5S_06.webp`}
              />
              <img
                alt="Metal charm (Chuls ver.)"
                loading="lazy"
                src={`${baseImgUrl}/novelty/SG-CASE-5S_08.webp`}
              />
            </div>

            <p className="header-squid-game__novelty__card-date">
              <span>Pre-order Period</span>
              <span>Fri, 20 Jun 2025 – Fri, 27 Jun 2025</span>
            </p>

            <p className="header-squid-game__novelty__card-text">
              With the purchase of a SQUID GAME frame , you’ll receive one of two exclusive
              collaboration items—chosen at random.
            </p>

            <ul className="header-squid-game__novelty__card-notes">
              {NOVELTY.NOTES.map((text, index) => (
                <li key={`squid-game__novelty-${index + 1}`}>{text}</li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className="header-squid-game__lineup-nav" id="lineup">
        <h2 className="base-squid-game__title">
          <strong>LINEUP</strong>
          <img alt="LINEUP" loading="lazy" src={`${baseImgUrl}/lineup/lineup-title.svg`} />
        </h2>

        <nav className="header-squid-game__lineup-nav__list">
          <ul className="header-squid-game__lineup-nav__list--sp">{renderNavItem()}</ul>
          <Slider {...navSettings} className="header-squid-game__lineup-nav__list--pc">
            {renderNavItem()}
          </Slider>
        </nav>
      </section>
    </Fragment>
  );
};
